import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-retroalimentacion-trabajo-criterios',
  standalone: false,
  templateUrl: './retroalimentacion-trabajo-criterios.component.html',
  styleUrls: ['../retroalimentacion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RetroalimentacionTrabajoCriteriosComponent implements OnInit {

  @Input()
  alumno$: Observable<any>;

  @Input()
  alumnos$: Observable<any>;

  @Input()
  eventoUnidadId: number;
  @Input()
  criterios: any[];
  @Input()
  fechaActual$: Observable<any>;
  @Input()
  mostrarAutoevaluacion$: Observable<boolean>;

  constructor() { }

  ngOnInit(): void {
  }

}
